import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import ReactHtmlParser from 'react-html-parser';
// import useSpan from '../../hooks/useSpan';
import Spacer from './Spacer';

const List = (props) => {
  const { innerHTML } = props;

  // const currentBreakpoint = useSpan('Narrow');
  const parsedHTML = ReactHtmlParser(innerHTML);

  return (
    <>
      <Row>
        <Col
          xs={{
            offset: 2,
            span: 20,
          }}
          md={{ offset: 5, span: 11 }}
        >
          {parsedHTML}
        </Col>
      </Row>
      <Spacer size="Mid" />
    </>
  );
};

List.propTypes = {
  innerHTML: PropTypes.shape.isRequired,
};

export default List;
